import React, { useEffect, useRef, useState } from "react";
import "../../css_files/Reports/OrderGraphs.css";
import { Chart } from "chart.js";
import axiosInstance from "../../api";

function OrderGraphs() {
  const chartRef = useRef([]);
  const chartInstanceRef = useRef([]);

  const [dateData, setDateData] = useState({
    date: new Date().toISOString().split("T")[0],
    month: (new Date().getMonth() + 1).toString().padStart(2, "0"),
    year: new Date().getFullYear().toString(),
  });

  const [enquirydate, setEnquiryDate] = useState({
    date: new Date().toISOString().split("T")[0],
    month: (new Date().getMonth() + 1).toString().padStart(2, "0"),
    year: new Date().getFullYear().toString(),
  });

  const [enquiryData, setEnquiryData] = useState([]);

  function getOrdersAsofToday() {
    if (!chartRef.current[0]) return;
    if (chartInstanceRef.current[0]) {
      chartInstanceRef.current[0].destroy();
    }
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/DashboardReport/GetOrdersWithPendingOrNoDues?dateTime=${dateData.date}`
      )
      .then((result) => {
        chartInstanceRef.current[0] = new Chart(
          chartRef.current[0].getContext("2d"),
          {
            type: "doughnut",
            data: {
              labels: ["Zero Dues", "Pending Dues"],
              datasets: [
                {
                  label: "Orders",
                  data: [
                    result.data.reduce(
                      (acc, curr) =>
                        curr.totalAmountToPay === curr.amountPaid
                          ? acc + 1
                          : acc,
                      0
                    ),
                    result.data.reduce(
                      (acc, curr) =>
                        curr.totalAmountToPay !== curr.amountPaid
                          ? acc + 1
                          : acc,
                      0
                    ),
                  ],
                  backgroundColor: ["#FF6384", "#36A2EB"],
                  hoverOffset: 4,
                },
              ],
            },
          }
        );
      })
      .catch(console.log);
  }

  function getOrdersAsofMonth() {
    if (!chartRef.current[1]) return;
    if (chartInstanceRef.current[1]) {
      chartInstanceRef.current[1].destroy();
    }
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/DashboardReport/GetOrdersWithPendingOrNoDues?month=${dateData.month}&year=${dateData.year}`
      )
      .then((result) => {
        chartInstanceRef.current[1] = new Chart(
          chartRef.current[1].getContext("2d"),
          {
            type: "doughnut",
            data: {
              labels: ["Zero Dues", "Pending Dues"],
              datasets: [
                {
                  label: "Orders",
                  data: [
                    result.data.reduce(
                      (acc, curr) =>
                        curr.totalAmountToPay === curr.amountPaid
                          ? acc + 1
                          : acc,
                      0
                    ),
                    result.data.reduce(
                      (acc, curr) =>
                        curr.totalAmountToPay !== curr.amountPaid
                          ? acc + 1
                          : acc,
                      0
                    ),
                  ],
                  backgroundColor: ["#FF6384", "#36A2EB"],
                  hoverOffset: 4,
                },
              ],
            },
          }
        );
      })
      .catch(console.log);
  }
  function getOrdersAsofYear() {
    if (!chartRef.current[2]) return;
    if (chartInstanceRef.current[2]) {
      chartInstanceRef.current[2].destroy();
    }
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/DashboardReport/GetOrdersWithPendingOrNoDues?year=${dateData.year}`
      )
      .then((result) => {
        chartInstanceRef.current[2] = new Chart(
          chartRef.current[2].getContext("2d"),
          {
            type: "doughnut",
            data: {
              labels: ["Zero Dues", "Pending Dues"],
              datasets: [
                {
                  label: "Orders",
                  data: [
                    result.data.reduce(
                      (acc, curr) =>
                        curr.totalAmountToPay === curr.amountPaid
                          ? acc + 1
                          : acc,
                      0
                    ),
                    result.data.reduce(
                      (acc, curr) =>
                        curr.totalAmountToPay !== curr.amountPaid
                          ? acc + 1
                          : acc,
                      0
                    ),
                  ],
                  backgroundColor: ["#FF6384", "#36A2EB"],
                  hoverOffset: 4,
                },
              ],
            },
          }
        );
      })
      .catch(console.log);
  }

  function getEnquiriesPriorities(date, month, year, index) {
    if (!chartRef.current[index]) return;
    if (chartInstanceRef.current[index]) {
      chartInstanceRef.current[index].destroy();
    }

    const filteredEnquiries = enquiryData.filter((x) => {
      const dateOfEnquiry = x.dateOfEnquiry.split("T")[0];
      if (date) {
        return dateOfEnquiry === date;
      }

      if (month) {
        return (
          dateOfEnquiry.split("-")[1] == month &&
          dateOfEnquiry.split("-")[0] == year
        );
      } else if (year) {
        return dateOfEnquiry.split("-")[0] == year;
      }
    });

    chartInstanceRef.current[index] = new Chart(
      chartRef.current[index].getContext("2d"),
      {
        type: "doughnut",
        data: {
          labels: ["High", "Medium", "Low"],
          datasets: [
            {
              label: "Priority",
              data: [
                filteredEnquiries.reduce((acc, curr) => {
                  if (curr.priority === "High") {
                    return acc + 1;
                  }
                  return acc;
                }, 0),
                filteredEnquiries.reduce((acc, curr) => {
                  if (curr.priority === "Medium") {
                    return acc + 1;
                  }
                  return acc;
                }, 0),
                filteredEnquiries.reduce((acc, curr) => {
                  if (curr.priority === "Low") {
                    return acc + 1;
                  }
                  return acc;
                }, 0),
              ],
              backgroundColor: ["#FF6384", "#36A2EB", "green"],
              hoverOffset: 4,
            },
          ],
        },
      }
    );
  }

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/NewEnquiry/GetEnquiriesDropdown`
      )
      .then((res) => {
        setEnquiryData(res.data);
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    getEnquiriesPriorities(enquirydate.date, null, null, 3);
    getEnquiriesPriorities(null, enquirydate.month, enquirydate.year, 4);
    getEnquiriesPriorities(null, null, enquirydate.year, 5);

    return function () {
      chartInstanceRef.current[3]?.destroy();
      chartInstanceRef.current[4]?.destroy();
      chartInstanceRef.current[5]?.destroy();
    };
  }, [enquiryData, enquirydate]);

  useEffect(() => {
    getOrdersAsofToday();
    getOrdersAsofMonth();
    getOrdersAsofYear();

    return function () {
      chartInstanceRef.current[0]?.destroy();
      chartInstanceRef.current[1]?.destroy();
      chartInstanceRef.current[2]?.destroy();
    };
  }, [dateData]);

  return (
    <div className="order-graphs-overview">
      <aside>
        <h3>Orders As of Today</h3>
        <input
          type="date"
          value={dateData.date}
          onChange={(e) => setDateData({ ...dateData, date: e.target.value })}
        />
        <figure>
          <canvas ref={(el) => (chartRef.current[0] = el)}></canvas>
        </figure>
      </aside>
      <aside>
        <h3>Orders As of Month</h3>
        <select
          onChange={(e) => setDateData({ ...dateData, month: e.target.value })}
        >
          <option value="">Select Month</option>
          <option value="01" selected={dateData.month === "01"}>
            January
          </option>
          <option value="02" selected={dateData.month === "02"}>
            February
          </option>
          <option value="03" selected={dateData.month === "03"}>
            March
          </option>
          <option value="04" selected={dateData.month === "04"}>
            April
          </option>
          <option value="05" selected={dateData.month === "05"}>
            May
          </option>
          <option value="06" selected={dateData.month === "06"}>
            June
          </option>
          <option value="07" selected={dateData.month === "07"}>
            July
          </option>
          <option value="08" selected={dateData.month === "08"}>
            August
          </option>
          <option value="09" selected={dateData.month === "09"}>
            September
          </option>
          <option value="10" selected={dateData.month === "10"}>
            October
          </option>
          <option value="11" selected={dateData.month === "11"}>
            November
          </option>
          <option value="12" selected={dateData.month === "12"}>
            December
          </option>
        </select>
        <figure>
          <canvas ref={(el) => (chartRef.current[1] = el)}></canvas>
        </figure>
      </aside>
      <aside>
        <h3>Orders As of Year</h3>
        <select
          onChange={(e) => setDateData({ ...dateData, year: e.target.value })}
        >
          <option value="">Select Year</option>
          {Array.from({ length: 150 }, (_, i) => `${1970 + i}`).map((x) => (
            <option value={x} selected={dateData.year === x}>
              {x}
            </option>
          ))}
        </select>
        <figure>
          <canvas ref={(el) => (chartRef.current[2] = el)}></canvas>
        </figure>
      </aside>
      <aside>
        <h3>Enquiry Priorities As of Today</h3>
        <input
          type="date"
          value={enquirydate.date}
          onChange={(e) =>
            setEnquiryDate({ ...enquirydate, date: e.target.value })
          }
        />
        <figure>
          <canvas ref={(el) => (chartRef.current[3] = el)}></canvas>
        </figure>
      </aside>
      <aside>
        <h3>Enquiry Priorities As of Month</h3>
        <select
          onChange={(e) =>
            setEnquiryDate({ ...enquirydate, month: e.target.value })
          }
        >
          <option value="">Select Month</option>
          <option value="01" selected={enquirydate.month === "01"}>
            January
          </option>
          <option value="02" selected={enquirydate.month === "02"}>
            February
          </option>
          <option value="03" selected={enquirydate.month === "03"}>
            March
          </option>
          <option value="04" selected={enquirydate.month === "04"}>
            April
          </option>
          <option value="05" selected={enquirydate.month === "05"}>
            May
          </option>
          <option value="06" selected={enquirydate.month === "06"}>
            June
          </option>
          <option value="07" selected={enquirydate.month === "07"}>
            July
          </option>
          <option value="08" selected={enquirydate.month === "08"}>
            August
          </option>
          <option value="09" selected={enquirydate.month === "09"}>
            September
          </option>
          <option value="10" selected={enquirydate.month === "10"}>
            October
          </option>
          <option value="11" selected={enquirydate.month === "11"}>
            November
          </option>
          <option value="12" selected={enquirydate.month === "12"}>
            December
          </option>
        </select>
        <figure>
          <canvas ref={(el) => (chartRef.current[4] = el)}></canvas>
        </figure>
      </aside>
      <aside>
        <h3>Enquiry Priorities As of Year</h3>
        <select
          onChange={(e) =>
            setEnquiryDate({ ...enquirydate, year: e.target.value })
          }
        >
          <option value="">Select Year</option>
          {Array.from({ length: 150 }, (_, i) => `${1970 + i}`).map((x) => (
            <option value={x} selected={enquirydate.year === x}>
              {x}
            </option>
          ))}
        </select>
        <figure>
          <canvas ref={(el) => (chartRef.current[5] = el)}></canvas>
        </figure>
      </aside>
    </div>
  );
}

export default OrderGraphs;
